import useTranslation  from '../../features/translation/hooks/useTranslation';
import './NotFound.scss';

enum TranslationKeys {
    ICON_SIZE = 'fwe-icon-4x',
    NO_RESULTS_TITLE = 'resultNoResultFirstSentence',
    NO_RESULTS_MESSAGE = 'resultNoResultSecondSentence'
}

export default function NotFound (): JSX.Element {

    const t = useTranslation();

    return (
        <div className="no-results-container">
            <i className= {`fwe-icon fwe-icon-documents-no-data ${TranslationKeys.ICON_SIZE}`}></i>
            <p className="bold">{t(TranslationKeys.NO_RESULTS_TITLE)}</p>
            <p className="font-weight-light text-centered">{t(TranslationKeys.NO_RESULTS_MESSAGE)}</p>
        </div>
    )
}
